import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  MenuItem,
  Modal,
  Slide,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  useTheme
} from '@mui/material';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ClusterConfigPage from '../../../pages/ClusterConfigPage';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import generateAlias from '../../../utils/generateAliasForNode';

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const NodeModalCluster = ({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) => {
  const { enqueueSnackbar } = useSnackbar();

  const INITIALSTATE = {
    alias: generateAlias(nodeName, nodeId),
    df: '',
    path: '',
    // db_name: 'default',
    // statement: '',
  };
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [uniqueId, setUniqueId] = useState('');
  const [columnName, setColumnName] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState([]);

  const [configData, setConfigData] = useState([
    {
      id: 1,
      column: '',
      matchingCriteria: '',
    },
  ]);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleUniqueId = (event) => {
    setUniqueId(event.target.value);
    // setSelectedColumnName(event.target.value);
    selectedColumnName.length === 0
      ? setSelectedColumnName([...selectedColumnName, event.target.value])
      : setSelectedColumnName((prevData) => {
          const newData = [...prevData];
          newData[0] = event.target.value;
          return newData;
        });
  };

  const handleChange = (event, index) => {
    const data = [...configData];
    data[index][event.target.name] =
      event.target.name === 'threshold' && event.target.value ? parseInt(event.target.value, 10) : event.target.value;
    if (event.target.name === 'column') {
      setSelectedColumnName((prevData) => {
        const newData = [...prevData];
        newData[index + 1] = event.target.value;
        return newData;
      });
    }
    const updatedData = data.map((item) => {
      if (
        item.matchingCriteria === 'fuzzy_unordered' ||
        item.matchingCriteria === 'fuzzy' ||
        item.matchingCriteria === 'fuzzy_or_null'
      ) {
        return {
          ...item,
          threshold: item.threshold,
        };
      }
      return item;
    });

    // console.log(event.target.name, event.target.value, updatedData);
    setConfigData(updatedData);
  };

  const handleAdd = () => {
    if (columnName.length === selectedColumnName.length) {
      enqueueSnackbar('Max Limit Reached!!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } else if (configData[configData.length - 1].column) {
      setConfigData([
        ...configData,
        { id: configData[configData.length - 1].id + 1, column: '', matchingCriteria: '' },
      ]);
    } else {
      enqueueSnackbar('Select column to proceed!!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const handleDelete = (data) => {
    const filteredData = configData.filter((item) => item.column !== data.column);
    // console.log(data, filteredData, configData, configData.length);
    configData.length === 1
      ? setConfigData([
          {
            id: 1,
            column: '',
            matchingCriteria: '',
          },
        ])
      : setConfigData(filteredData);
    setSelectedColumnName(selectedColumnName.filter((item) => item !== data.column));
  };

  const getSourceData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;
      let filePath;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            setHeaderName(node.headerName);
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
            filePath = node.formField.path;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias, path: filePath });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const head = [];

      const newHeader = uniqueArray.map((el) => {
        return {
          ...el,
          header: el.alias ? el.alias : el.header,
          alias: el.alias ? '' : el.alias,
        };
      });

      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setHeaders(head);
      setFetchedHeader(newHeader);
      setColumnName(newHeader.map((item) => ({ id: item.header, label: item.header })));

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setTempHeader(node.headerName);
          setUniqueId(node.uniqueId);
          setColumnName(node.columnName);
          setSelectedColumnName(node.selectedColumnName);
          setConfigData(node.configData);
          // setFields(node.fields);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getSourceData();
  }, [nodeId]);

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);
      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const head = [];

      const newHeader = uniqueArray.map((el) => {
        return {
          ...el,
          header: el.alias ? el.alias : el.header,
          alias: el.alias ? '' : el.alias,
        };
      });

      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setHeaders(head);

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }
    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        // y_axis = `${parseInt(el.position.y, 10)}`;
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const lastColumnName = columnName
      .filter((item) => item.label === configData[configData.length - 1].column)
      .map((item) => item.label)[0];

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      configData,
      columnName,
      selectedColumnName,
      uniqueId,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '80%', marginLeft: '20%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {/* {nodeName} */}
                Match
              </Typography>

              <Tooltip title="Refresh Schema" placement="left">
                <IconButton edge="start" onClick={refreshAllState} aria-label="close" sx={{ color: '#00043C' }}>
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                  // onClick={handleFormsubmit}
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: '20px' }}>
            <TextField
              id="outlined-select-currency"
              select
              required
              name="algorithm"
              label="Algorithm"
              size="small"
              value="Levenshtein"
              // onChange={handleInputChange}
              disabled={disableForm}
              // fullWidth
              style={{ margin: '16px', width: '250px' }}
            >
              <MenuItem value="Levenshtein">Levenshtein</MenuItem>
              <MenuItem value="Jaccard Similarity">Jaccard Similarity</MenuItem>
              <MenuItem value="Jaro-Winkler Distance">Jaro-Winkler Distance</MenuItem>
              <MenuItem value="N-gram Similarity">N-gram Similarity</MenuItem>
              <MenuItem value="Hash Based Deduplication">Hash Based Deduplication</MenuItem>
              <MenuItem value="Fingerprinting-MinHash">Fingerprinting-MinHash</MenuItem>
            </TextField>
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root': { m: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              {fetchedHeader.length !== 0 && (
                <Box>
                  <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
                    {/* <AppBar position="static">
                      <Tabs
                        value={value}
                        onChange={handleTabChange}
                        indicatorColor="white"
                        textColor="white"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        sx={{
                          color: "#000",
                          "& button": { backgroundColor: "#eee" },
                          "& button:focus": {
                            color: "white",
                            backgroundImage:
                              "linear-gradient(to right, #4880EC, #019CAD)",
                          },
                          "& button.Mui-selected": {
                            color: "white",
                            backgroundImage:
                              "linear-gradient(to right, #4880EC, #019CAD)",
                          },
                        }}
                      >
                        <Tab label="Config" {...a11yProps(0)} />
                        <Tab label="Result" {...a11yProps(1)} />
                      </Tabs>
                    </AppBar> */}
                    <>
                      <TabPanel value={value} index={0} dir={theme.direction}>
                        <Box sx={{ width: '100%', height: '100%' }}>
                          <ClusterConfigPage
                            uniqueId={uniqueId}
                            columnName={columnName}
                            handleUniqueId={handleUniqueId}
                            handleAdd={handleAdd}
                            handleDelete={handleDelete}
                            configData={configData}
                            selectedColumnName={selectedColumnName}
                            handleChange={handleChange}
                            disableForm={disableForm}
                          />
                        </Box>
                      </TabPanel>
                      {/* <TabPanel value={value} index={1} dir={theme.direction}>
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "red",
                          }}
                        >
                          <ClusterResultPage />
                        </Box>
                      </TabPanel> */}
                    </>
                  </Box>
                </Box>
              )}
            </Box>
          </div>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

NodeModalCluster.propTypes = {
  changeNodeName: PropTypes.func,
  edges: PropTypes.shape({
    forEach: PropTypes.func,
  }),
  handleClose: PropTypes.func,
  nodeId: PropTypes.string,
  nodeName: PropTypes.string,
  nodes: PropTypes.shape({
    forEach: PropTypes.func,
  }),
  open: PropTypes.bool,
  setNodes: PropTypes.func,
};

export default NodeModalCluster;
